<div *ngIf="id" class="form-group m-form__group m-form__group--colored m--margin-top-15 m--padding-15">
  <div *ngIf="!isLoading.list" class="m--padding-left-15 m--padding-right-15">
    <h5 class="m--margin-bottom-15">{{ 'suppliers-contract.agreements' | transloco }}</h5>

    <div class="is--highlights" *ngFor="let item of list; let i = index">
      <div class="row m--padding-bottom-15">
        <span class="m--margin-top-5">{{ i + 1 }}.</span>

        <div class="col-lg-2 col-md-2 col-sm-12">
          <app-organization-select [countryId]="countryId" [(ngModel)]="item.organization.id"></app-organization-select>
        </div>

        <div class="col-lg-2 col-md-2 col-sm-12">
          <input type="text" class="form-control m-input" [(ngModel)]="item.number" [placeholder]="'suppliers-contract.num' | transloco">
        </div>

        <div class="col-lg-2 col-md-4 col-sm-12">
          <hx-date-select [(ngModel)]="item.date"></hx-date-select>
        </div>

        <div class="col-lg-2 col-md-4 col-sm-12">
          <input type="text" class="form-control m-input" [(ngModel)]="item.title" [placeholder]="'suppliers-contract.name' | transloco">
        </div>

        <div class="col-lg-3 col-md-4 col-sm-12">
          <div class="input-group">
            <input type="text" class="form-control m-input" [(ngModel)]="item.note" [placeholder]="'suppliers-contract.note' | transloco">

            <span class="input-group-btn">
              <button (click)="updateData(item)" [ngbTooltip]="'suppliers-contract.save' | transloco" class="btn btn-success btn-thin" type="button">
                <i class="la la-save"></i>
              </button>
              <button (click)="removeField(item, i)" [ngbTooltip]="'suppliers-contract.delete' | transloco" class="btn btn-danger btn-thin" type="button">
                <i class="la la-trash"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right">
      <div class="modal-footer modal-footer--pad-right">
        <button (click)="addItem()" class="btn btn-success m-btn--icon" type="button">
          <span>
            <i class="la la-plus"></i>
            <span>{{ 'suppliers-contract.btn.addAgreements' | transloco }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading.list" class="m-page-loader m-page-loader--non-block m-page-loader--relative">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>
